<script setup lang="ts">
import PageContainer from "~/components/ui/PageContainer.vue";

const sections = [
  { title: "Prose Short Questions", to: "/11th/english/prose/", description: "Prose units ke short questions aur answers." },
  { title: "Poems Short Questions", to: "/11th/english/poems/", description: "Poetic idea, tone aur stanza-based short prep." },
  { title: "Play Short Questions", to: "/11th/english/play/", description: "Unit 14 ke quick subjective answers." },
  { title: "Solved Exercise Questions", to: "/11th/english/solved-exercise/", description: "Textbook exercise-based short answers." },
];

const proseUnits = [
  { title: "Unit 1: Khatam-un-Nabiyeen Hazrat Muhammad", to: "/11th/english/prose/khatam-un-nabiyeen-hazrat-muhammad/" },
  { title: "Unit 2: Responsibility of the Youth in Nation-Building", to: "/11th/english/prose/responsibility-of-the-youth-in-nation-building/" },
  { title: "Unit 4: Team Moon", to: "/11th/english/prose/team-moon/" },
  { title: "Unit 5: Impact of Global Warming on Pakistan", to: "/11th/english/prose/impact-of-global-warming-on-pakistan/" },
  { title: "Unit 7: What You Do is What You Are", to: "/11th/english/prose/what-you-do-is-what-you-are/" },
  { title: "Unit 8: Clean Water", to: "/11th/english/prose/clean-water/" },
  { title: "Unit 10: The Punishment of Shahpesh, the Persian, on Khipil, the Builder", to: "/11th/english/prose/the-punishment-of-shahpesh-the-persian-on-khipil-the-builder/" },
  { title: "Unit 12: The Impact of AI on Society, Human Relationships, and Ethics", to: "/11th/english/prose/the-impact-of-ai-on-society-human-relationships-and-ethics/" },
];

const faqs = [
  {
    question: "What is the purpose of this short-questions page?",
    answer: "Yeh page prose, poems, play aur solved exercise ke short questions tak le jata hai.",
  },
  {
    question: "Why are prose units highlighted separately here?",
    answer: "Prose units me board paper ke liye short questions zyada aate hain, is liye unhen alag dikhaya gaya hai.",
  },
  {
    question: "Do these pages also include MCQs?",
    answer: "Haan, kai prose pages par short questions ke sath MCQs bhi milte hain.",
  },
];

usePageSeo({
  title: "11th Class English Short Questions | Chapter Wise SQS Prep",
  description: "11th class English short questions ke liye prose, poems, play aur solved exercise based chapter-wise entry routes.",
  keywords: "11th class english short questions, class 11 english sqs, 1st year english short questions, chapter wise short questions english",
  schemaType: "CollectionPage",
  schemaProperties: {
    mainEntity: {
      "@type": "ItemList",
      itemListElement: [...sections, ...proseUnits].map((item, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: item.title,
        url: `https://ustaad.today${item.to}`,
      })),
    },
  },
  faqs,
  breadcrumbs: [
    { name: "Home", item: "/" },
    { name: "11th English", item: "/11th/english/" },
    { name: "Short Questions", item: "/11th/english/short-questions/" },
  ],
});
</script>

<template>
  <PageContainer>
    <EnglishHero
      headline="Short Question Revision"
      title="11th Class English Short Questions"
      description="Yahan se aap short questions ki tayari ke liye sahi section aur chapter khol sakte hain."
    />

    <EnglishSection
      title="Short-Question Routes"
      description="Jis type ke short questions chahiye, woh section choose karein."
    >
      <EnglishGrid>
        <EnglishCard
          v-for="section in sections"
          :key="section.to"
          :title="section.title"
          :description="section.description"
          :to="section.to"
        />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection
      title="Start With Prose Units"
      description="Prose ke ye chapters short questions ke liye zyada important hain."
    >
      <EnglishGrid>
        <EnglishCard
          v-for="unit in proseUnits"
          :key="unit.to"
          :title="unit.title"
          description="Is chapter ke short questions aur answers dekhain."
          :to="unit.to"
        />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection
      title="FAQs"
      description="Short questions ke bare me aam sawalon ke jawab."
    >
      <EnglishGrid>
        <EnglishCard
          v-for="item in faqs"
          :key="item.question"
          :title="item.question"
          :description="item.answer"
        />
      </EnglishGrid>
    </EnglishSection>
  </PageContainer>
</template>
